import { gql } from 'graphql-request'

export const SINCRONIZAR_IDENTITY_PROVIDER = gql`
  mutation SincronizarIdentityProvider($emailUsuario: String!) {
    sincronizarIdentityProvider(emailUsuario: $emailUsuario)
  }
`
